/**
 * Theme entry point.
 * jQuery ($) is available when loaded after the jQuery script in theme.liquid.
 */

function initTheme() {
  initPreHeader();
  initMobileHeaderSearch();
  fixedHeaderDesktop();
}

// Catalog dropdown runs on DOMContentLoaded - does not depend on jQuery/Slick
function initCatalogDropdown() {
  const triggers = document.querySelectorAll('[data-catalog-trigger]');

  function closeAllDropdowns() {
    document.querySelectorAll('.header__catalog-dropdown.is-open').forEach((dropdown) => {
      dropdown.setAttribute('hidden', '');
      dropdown.classList.remove('is-open');
    });
    document.querySelectorAll('[data-catalog-trigger]').forEach((t) => {
      t.setAttribute('aria-expanded', 'false');
    });
    document.body.style.overflow = '';
  }

  triggers.forEach((trigger) => {
    const targetId = trigger.getAttribute('data-catalog-target');
    const dropdown = targetId ? document.getElementById(targetId) : null;

    if (!dropdown) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (dropdown.classList.contains('is-open')) {
        closeAllDropdowns();
      } else {
        closeAllDropdowns();
        dropdown.removeAttribute('hidden');
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-catalog-close]').forEach((el) => {
    el.addEventListener('click', closeAllDropdowns);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (document.querySelector('[data-mobile-nav-drawer].is-open')) return;
    closeAllDropdowns();
  });
}

function initMobileNavDrawer() {
  const drawer = document.querySelector('[data-mobile-nav-drawer]');
  const triggers = document.querySelectorAll('[data-mobile-nav-trigger]');
  if (!drawer || triggers.length === 0) return;

  const views = drawer.querySelectorAll('[data-mobile-nav-view]');
  /** @type {string[]} */
  let stack = ['root'];

  function getView(id) {
    return drawer.querySelector(`[data-mobile-nav-view="${id}"]`);
  }

  function showView(id) {
    views.forEach((el) => {
      const match = el.getAttribute('data-mobile-nav-view') === id;
      if (match) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function resetNav() {
    stack = ['root'];
    showView('root');
  }

  function openDrawer() {
    drawer.removeAttribute('hidden');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    resetNav();
    const closeBtn = drawer.querySelector('.header-mobile-nav__close');
    if (closeBtn instanceof HTMLElement) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.setAttribute('hidden', '');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    resetNav();
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  });

  drawer.querySelectorAll('[data-mobile-nav-close]').forEach((el) => {
    el.addEventListener('click', () => {
      closeDrawer();
    });
  });

  drawer.querySelectorAll('[data-mobile-nav-go]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-mobile-nav-go');
      if (!id) return;
      const next = getView(id);
      if (!next) return;
      stack.push(id);
      showView(id);
    });
  });

  drawer.querySelectorAll('[data-mobile-nav-back]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (stack.length <= 1) return;
      stack.pop();
      const id = stack[stack.length - 1];
      showView(id);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
    closeDrawer();
  });
}

function initMobileHeaderSearch() {
  const predictiveSearch = document.querySelector('.header__predictive-search');
  const searchButton = document.querySelector('.header__search-button');
  const mobileSearchButton = document.querySelector('.header__search-clear');
  const searchInput = document.querySelector('.header__search-input');
  if (!predictiveSearch || !searchButton || !searchInput) return;

  const closeSearch = () => {
    predictiveSearch.classList.remove('is-open');
    searchInput.blur();
  };

  searchButton.addEventListener('click', (e) => {
    if (window.innerWidth > 1024) return;
    e.preventDefault();
    if (predictiveSearch.classList.contains('is-open')) {
      closeSearch();
    } else {
      predictiveSearch.classList.add('is-open');
      setTimeout(() => searchInput.focus(), 50);
    }
  });

  mobileSearchButton.addEventListener('click', (e) => {
    if (window.innerWidth > 1024) return;
    e.preventDefault();
    if (predictiveSearch.classList.contains('is-open')) {
      closeSearch();
    }
  });

  document.addEventListener('click', (e) => {
    if (!predictiveSearch.classList.contains('is-open')) return;
    if (predictiveSearch.contains(e.target)) return;
    closeSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && predictiveSearch.classList.contains('is-open')) {
      closeSearch();
    }
  });
}

function fixedHeaderDesktop() {
  const preHeader = document.querySelector('.pre-header');
  const header = document.querySelector('.header--desktop');
  if (!preHeader) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50 && window.innerWidth > 1024) {
      preHeader.classList.add('is-fixed');
      header.classList.add('is-fixed');
    } else {
      preHeader.classList.remove('is-fixed');
      header.classList.remove('is-fixed');
    }
  });
}

function initPreHeader() {
  const carousel = document.querySelector('.pre-header__content-carousel');
  if (!carousel || typeof $ === 'undefined' || !$.fn.slick) return;
  const items = carousel.querySelectorAll('.pre-header__content-carousel-item');
  if (items.length <= 1) return;

  $('.pre-header__content-carousel').slick({
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000
  });
}

function whenReady(fn) {
  if (typeof $ !== 'undefined' && $.fn.slick) {
    fn();
  } else {
    setTimeout(() => whenReady(fn), 50);
  }
}

function onDOMReady() {
  initCatalogDropdown();
  initMobileNavDrawer();
  whenReady(initTheme);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onDOMReady);
} else {
  onDOMReady();
}
